import { jsx as r, jsxs as s } from "react/jsx-runtime";
import { TextLink as t } from "../../../atoms/TextLink/TextLink.es.js";
import { chakra as e } from "@chakra-ui/react";
import { useFooterStyle as a } from "../Footer.context.es.js";
const c = () => {
  const i = a();
  return /* @__PURE__ */ r(e.div, { __css: i.nav, children: /* @__PURE__ */ r(e.nav, { children: /* @__PURE__ */ s(e.ul, { children: [
    /* @__PURE__ */ r(e.li, { __css: i.navItem, children: /* @__PURE__ */ r(
      t,
      {
        variant: "primary",
        size: "sm",
        href: "https://app.usefoam.com/terms",
        isBold: !0,
        target: "_blank",
        children: "Website Terms"
      }
    ) }),
    /* @__PURE__ */ r(e.li, { __css: i.navItem, children: /* @__PURE__ */ r(
      t,
      {
        variant: "primary",
        size: "sm",
        href: "https://app.usefoam.com/privacy",
        isBold: !0,
        target: "_blank",
        children: "Privacy"
      }
    ) }),
    /* @__PURE__ */ r(e.li, { __css: i.navItem, children: /* @__PURE__ */ r(t, { variant: "primary", size: "sm", href: "mailto:hello@foam.io", isBold: !0, children: "Contact" }) })
  ] }) }) });
};
export {
  c as FooterNavigation
};
//# sourceMappingURL=FooterNavigation.es.js.map
